export const adjustToHeight = function (el) {
    document.fonts.ready.then(() => {
        const height = document
            .querySelector(".project__text")
            .getBoundingClientRect().height;
        if (window.innerWidth > 768) {
            el.style.top = `${height}px`;
        }
    });
};

export const clonePosition = function (el) {
    const selector = el.getAttribute("data-selector");
    const clonable = document.querySelector(selector);
    const clonableCoordinates = clonable.getBoundingClientRect();

    el.style.top = clonableCoordinates.top + "px";
};

export const followLinkAttribute = function (el) {
    const url = el.getAttribute("data-link");
    window.location.href = url;
};
